import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export function success(message: string) {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
  });
}
export function error(message: string) {
  toast.error(message);
  
}
export function warning(message: string) {
  toast.warning(message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      progress: undefined,
    });
}
export function info(message: string) {
  toast.info(message);
}
